import { Router } from '@angular/router';
import StorageUtils from "../../shared/utilities/storage.utils";

export class BaseComponent {
    public accountId: number = 0;

    constructor(private baseRouter: Router) {
        this.baseInterceptUrl(window.location.pathname);
    }

    /// PRIVATE FUNCTIONS
    private baseInterceptUrl(url?: string) {
        const urlReferrerHasSuperAdminAccess = StorageUtils.getLastUrl().indexOf('superAdminAccess') > -1;
        if (this.withSecondaryUserData() && urlReferrerHasSuperAdminAccess) {
            this.accountId = this.secondaryAdminUser().AccountId;
            if (url.indexOf('superAdminAccess') === -1) {
                this.baseRouter.navigateByUrl(url + `?superAdminAccess=1&accountId=${this.accountId}`);
            }
        }
    }

    /// PROPERTIES
    public currentLoggedUser(): any {
        let currentUserData = JSON.parse(localStorage.getItem('currentUser'));
        return currentUserData;
    }

    public secondaryAdminUser(): any {
        const withSecondaryUserData = this.withSecondaryUserData();
        return withSecondaryUserData ? withSecondaryUserData : {};
    }

    public currentRole(): string {
        return this.currentLoggedUser().role;
    }

    public withSecondaryUserData(): any {
        return JSON.parse(localStorage.getItem('secondaryAdminUser'));
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/base.component.ts